;(function( window, document, $, undefined ) {
	'use strict';

	// Carousels

	function carousels() {

    // Zoom Cards
    function zoomCards( $el ) {
      $el.slick({
        autoplay: false,
          arrows: true,
          dots: false,
          infinite: true,
          slidesToShow: 6,
          slidesToScroll: 6,
          responsive: [
            {
              breakpoint: 991,
              settings: {
                centerMode: true,
                centerPadding: '75px',
                autoplay: false,
                slidesToShow: 3,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: 768,
              settings: {
                centerMode: true,
                centerPadding: '75px',
                autoplay: false,
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 500,
              settings: {
                centerMode: true,
                centerPadding: '60px',
                autoplay: false,
                slidesToShow: 1
              }
            }
          ]
      });
    }

		// Globals
		return {
      zoomCards : zoomCards
		};

	}

	// Globals
	window.app = window.app || {};
  window.app.carousels = carousels();

})( window, document, jQuery );
